import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Divider } from "@/components/Divider";
import { ArrowLeft, Clock } from "lucide-react";

export default function ResourceDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setErr("Article not found"));
  }, [slug]);

  if (err) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center">
        <h1 className="font-heading font-bold text-3xl text-black">Article not found.</h1>
        <Link to="/resources" className="mt-6 inline-block text-[#00A651] font-bold uppercase text-sm tracking-wider">
          ← Back to Resources
        </Link>
      </div>
    );
  }
  if (!post) {
    return <div className="max-w-3xl mx-auto px-4 py-24">Loading…</div>;
  }

  return (
    <article className="bg-white" data-testid="page-resource-detail">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link
          to="/resources"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-black hover:text-[#00A651] font-bold mb-8"
          data-testid="resource-back"
        >
          <ArrowLeft size={14} /> All Resources
        </Link>
        <p className="text-xs uppercase tracking-[0.25em] text-[#00A651] font-bold">{post.category}</p>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl text-black mt-3 tracking-tight">
          {post.title}
        </h1>
        <Divider className="my-6" />
        <div className="flex items-center gap-4 text-xs text-gray-500 uppercase tracking-wider">
          <span>{post.author}</span>
          <span className="flex items-center gap-1"><Clock size={12} /> {post.read_minutes} min read</span>
        </div>
        {post.image_url && (
          <img src={post.image_url} alt={post.title} className="w-full aspect-[16/9] object-cover mt-8 rounded-sm" />
        )}
        <div className="prose prose-lg mt-10 font-body text-gray-800 whitespace-pre-line leading-relaxed">
          {post.content}
        </div>

        <div className="mt-12 bg-[#F8FAFC] border-l-4 border-l-[#00A651] p-6 rounded-sm">
          <h3 className="font-heading font-bold text-lg text-black">Ready to talk numbers?</h3>
          <p className="font-sub italic text-gray-600 mt-1">Apply or get a no-obligation quote.</p>
          <Link
            to="/apply"
            data-testid="resource-cta-apply"
            className="inline-block mt-4 bg-[#00A651] hover:bg-[#008f45] text-white font-bold uppercase tracking-wider text-sm px-6 py-3 rounded-sm transition-colors"
          >
            Start Application
          </Link>
        </div>
      </div>
    </article>
  );
}
